import { ActivityContactRelation } from '@/Data/ActivityContactRelation/ActivityContactRelationDataClass'
import { Company } from '@/Data/Company/CompanyDataClass'
import { CompanyPersonRelation } from '@/Data/CompanyPersonRelation/CompanyPersonRelationDataClass'
import { Person } from '@/Data/Person/PersonDataClass'
import {
  RelationCreateKey,
  RelationFilterKeyDist,
  RelationFilterKeySearch,
  RelationFilterKeySrc,
  RelationFilterValueDist,
  RelationGetAttribute,
} from '@/utils/CRUD/read/relational/const'
import { RelationalDataClassConfigs } from '@/utils/CRUD/read/relational/types'

export const RelationalSublistConfigs: RelationalDataClassConfigs = {
  ActivityPerson: {
    titleKey: 'pages.persons.title',
    relationalDataClass: {
      dataClass: ActivityContactRelation,
      filter: {
        keys: {
          src: RelationFilterKeySrc.ACTIVITY,
          dist: RelationFilterKeyDist.CONTACT_ENTITY,
          search: RelationFilterKeySearch.CONTACT_SEARCH,
        },
        values: {
          dist: RelationFilterValueDist.PERSON,
        },
      },
    },
    getter: {
      get: RelationGetAttribute.CONTACT,
      dataClass: Person,
    },
    setter: {
      src: RelationCreateKey.ACTIVITY,
      dist: RelationCreateKey.CONTACT,
    },
  },
  ActivityCompany: {
    titleKey: 'pages.companies.title',
    relationalDataClass: {
      dataClass: ActivityContactRelation,
      filter: {
        keys: {
          src: RelationFilterKeySrc.ACTIVITY,
          dist: RelationFilterKeyDist.CONTACT_ENTITY,
          search: RelationFilterKeySearch.CONTACT_SEARCH,
        },
        values: {
          dist: RelationFilterValueDist.COMPANY,
        },
      },
    },
    getter: {
      get: RelationGetAttribute.CONTACT,
      dataClass: Company,
    },
    setter: {
      src: RelationCreateKey.ACTIVITY,
      dist: RelationCreateKey.CONTACT,
    },
  },
  CompanyPerson: {
    titleKey: 'pages.persons.title',
    relationalDataClass: {
      dataClass: CompanyPersonRelation,
      filter: {
        keys: {
          src: RelationFilterKeySrc.COMPANY,
          search: RelationFilterKeySearch.PERSON_SEARCH,
        },
      },
    },
    getter: {
      get: RelationGetAttribute.PERSON,
      dataClass: Person,
    },
    setter: {
      src: RelationCreateKey.COMPANY,
      dist: RelationCreateKey.PERSON,
    },
  },
  PersonCompany: {
    titleKey: 'pages.companies.title',
    relationalDataClass: {
      dataClass: CompanyPersonRelation,
      filter: {
        keys: {
          src: RelationFilterKeySrc.PERSON,
          search: RelationFilterKeySearch.COMPANY_SEARCH,
        },
      },
    },
    getter: {
      get: RelationGetAttribute.COMPANY,
      dataClass: Company,
    },
    setter: {
      src: RelationCreateKey.PERSON,
      dist: RelationCreateKey.COMPANY,
    },
  },
}
